var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var fieldNames = {
            formTypeId: 'form_type_id',
            ymConversionEvent: 'ymConversionEvent',
            gaConversionEventCategory: 'gaConversionEventCategory',
            gaConversionEventAction: 'gaConversionEventAction'
        };

        var SOURCE_SEARCH_CRUISE = 3; // SiteCallback::SOURCE_SEARCH_CRUISE

        var translate = callbackTranslates;
        var links = callbackLinks;

        function openCallbackCityForm() {
            $('.w-clbk-type-show-callback-form').on('click', function (e) {
                // показать форму колбэка
                e.preventDefault();
                toggleMainCallbackFormModeList(false);
            });
            $('.w-clbk-type-show-write-back-form-for-whatsapp').on('click', function (e) {
                e.preventDefault();
                openMainCallback('writeBackOnWhatsapp', { formTypeName: 'writeBackOnWhatsapp' });
                toggleMainCallbackFormModeList(false);
            });
            $('.js-whatsapp-request').on('click', function (e) {
                e.preventDefault();
                window.brxTracking.sendAnalyticsEvent('write_whatsapp_mobile', {
                    'Is callback form': true
                });
                openMainCallback('writeOnWhatsappFastRequest', { formTypeName: 'writeOnWhatsappFastRequest' });
                toggleMainCallbackFormModeList(false);
            });
        }

        window.openMainCallback = function openMainCallback(openType, params) {
            open_popup({
                target: '.callback_form_popup.is_main',
                header: 1,
                footer: 0,
                place: 'bottom',
                onAfterShow: function onAfterShow($popup) {
                    if ((typeof params === "undefined" ? "undefined" : _typeof(params)) === 'object') {
                        if (typeof params.phone === 'string') {
                            $popup.find('input.callback_phone').val(params.phone);
                        }
                        if (params.formTypeName === 'pickUpTourForMe') {
                            // 5 - SiteCallbackFormTypeList::SOURCE_PICK_UP_TOUR_FOR_ME
                            $popup.find('input.callback_form_type_id').val(5);
                        }
                        var isWriteBackOnWhatsappForm = params.formTypeName === 'writeBackOnWhatsapp';
                        var isWriteOnWhatsappFastRequestForm = params.formTypeName === 'writeOnWhatsappFastRequest';
                        if (isWriteBackOnWhatsappForm || isWriteOnWhatsappFastRequestForm) {
                            // Чтобы не рисовать отдельную форму, пока будем подменять данные формы
                            if (isWriteOnWhatsappFastRequestForm) {
                                $popup.find('.w-clbk-title').text('Оставьте номер и мы сразу напишем вам на WhatsApp!');
                                $popup.find('.w-clbk-hint').text('');
                            } else {
                                $popup.find('.w-clbk-title').text('Оставить заявку');
                                $popup.find('.w-clbk-hint').text('Оставьте ваш номер, и мы с вами свяжемся');
                            }
                            $popup.find('.js-label').text('Я из города');
                            $popup.find('.get_callback').text('Напишите мне');
                            $popup.find('.get_callback').addClass('roistat-analytic-event');
                            $popup.find('.get_callback').attr('data-event', 'write_back_request_sent_mobile');

                            if (isWriteOnWhatsappFastRequestForm) {
                                // 7 - SiteCallbackFormTypeList::SOURCE_WRITE_ON_WHATSAPP_FAST_REQUEST
                                $popup.find('input.callback_form_type_id').val(7);
                                $('.w-clbk-delay-wrap').remove(); // Удалит выбор рабочего времени, мгновенная отбивка
                            } else {
                                // 6 - SiteCallbackFormTypeList::SOURCE_WRITE_TO_CLIENT_ON_WHATSAPP
                                $popup.find('input.callback_form_type_id').val(6);
                            }
                        }
                    }
                }
            });
        };

        $(document).ready(function () {
            var THEME_DEFAULT = 'default';
            var THEME_TOUR = 'tour';

            var themeCssClass = {
                'default': 'theme-' + THEME_DEFAULT,
                tour: 'theme-' + THEME_TOUR
            };
            function switchCallbackFormTheme($form, mode) {
                var $citiesLabel = $form.find('.w-clbk-cities .js-label');
                var citiesLabel = '';

                $form.removeClass(themeCssClass.default + ' ' + themeCssClass.tour);
                switch (mode) {
                    case THEME_TOUR:
                        $form.addClass(themeCssClass.tour);
                        citiesLabel = app.isOnlineBookingMode ? translate.phonesText : translate.phonesTextInCity;
                        break;
                    case THEME_DEFAULT:
                    default:
                        $form.addClass(themeCssClass.default);
                        citiesLabel = translate.forCityText + (app.isOnlineBookingMode ? '<br><small>' + translate.onlineBooking + '</small>' : '');
                        break;
                }

                $citiesLabel.html(citiesLabel);
            }

            var $promotionPage = $('.promotion-nauryz');
            if ($promotionPage.length) {
                $(window).on('onLocation', function (event, cityName, cityId) {
                    var $selectedCity = $promotionPage.find('.callback_city_id.hidden_value');
                    $selectedCity.trigger('setPseudoSelectValue', cityId);
                });
            }

            window.toggleMainCallbackFormModeList = function (showList) {
                var $mainModal = $('.callback_form_popup.is_main');
                $mainModal.find('.mpopup_body.mode-list').toggleClass('show-list', showList);
                if (!showList) {
                    var $result = $mainModal.find('.w-clbk-result');
                    if ($result.length) {
                        // Колбек
                        window.brxLazyImage.loadChildren($result[0]);
                    }
                }
            };

            $('#layoutBottomBtn').click(function () {
                $.ajax({
                    type: 'POST',
                    url: '/widget/updateCallbackPopupWidget',
                    success: function success(response) {
                        $('#callbackPopupBlock').replaceWith(response);
                        openMainCallback($(this).data('type'));
                        openCallbackCityForm();
                        window.brxTracking.callTrackingRefresh();
                    },
                    error: function error(_error) {
                        console.log(_error);
                    }
                });
            });

            openCallbackCityForm();

            // Действия взаимодействия с формой
            $('body').on('submit', '.w-clbk-form', function (e) {
                e.preventDefault();
                var $form = $(this);
                var $callBackForms = $('.w-clbk-form');
                var $callBackFormsWrap = $callBackForms.parent();
                var $title = $callBackFormsWrap.find('.w-clbk-r-title');
                var $hint = $callBackFormsWrap.find('.w-clbk-r-hint');
                var $delayWrap = $form.find('.w-clbk-delay-wrap');
                var $delayDate = $form.find('.callback_delay_date');
                var $delayTime = $form.find('.callback_delay_time');
                var is_choose_time = $delayWrap.length && !$delayWrap.hasClass('hide');

                var $formTypeIdInput = $form.find('input[name="' + fieldNames.formTypeId + '"]');
                var $ymConversionEventInput = $form.find('input[name="' + fieldNames.ymConversionEvent + '"]');

                var $gaConversionEventCategoryInput = $form.find('input[name="' + fieldNames.gaConversionEventCategory + '"]');
                var $gaConversionEventActionInput = $form.find('input[name="' + fieldNames.gaConversionEventAction + '"]');

                var gaConversionEvent = null;
                if ($gaConversionEventActionInput.val() && $gaConversionEventActionInput.val()) {
                    gaConversionEvent = {
                        category: $gaConversionEventCategoryInput.val(),
                        action: $gaConversionEventActionInput.val()
                    };
                }

                var params = {
                    city_id: $form.find('.callback_city_id').val(),
                    phone: $form.find('.callback_phone').val().trim(),
                    date: $delayDate.length ? $delayDate.val() : '',
                    time: $delayTime.length ? $delayTime.val() : '',
                    is_choose_time: is_choose_time,
                    form_type_id: $formTypeIdInput.val(),
                    ymConversionEvent: $ymConversionEventInput.length ? $ymConversionEventInput.val() : '',
                    gaConversionEvent: gaConversionEvent,
                    counter: $callBackForms.find('.callback_counter'),
                    onBeforeRequest: function onBeforeRequest() {
                        // блокируем кнопку, loading
                        $callBackForms.find('.get_callback').addClass('disabled').prop('disabled', true);
                        $callBackFormsWrap.addClass('with-result');
                        var $result = $callBackFormsWrap.find('.w-clbk-result');
                        if ($result.length) {
                            // на всякий. т.к. много где result отдельный (e.g. в модалке отеля)
                            // т.к. результат показывается сразу во всех формах на странице
                            $result.each(function (i, element) {
                                window.brxLazyImage.loadChildren(element);
                            });
                        }
                        $title.html(translate.creatingRequest);
                        $hint.html(translate.pleaseWait + ' ' + img_load);
                        // Пожалуйста подождите <img src="/img/load.gif">
                        // В остальных формах выставляем те же данные
                        // var $otherCallbackForms = $('.w-clbk-form').not($form);
                        // $otherCallbackForms.find('.callback_city_id').val(params.city_id)
                        //     .trigger('change');
                        // $otherCallbackForms.find('.callback_phone').val(params.phone);

                        $callBackForms.find('.field_phone').removeClass('error');
                    },
                    onResult: function onResult(data) {
                        var loading_class = 'success';
                        var title = '';
                        var hint = '';
                        if (data.error) {
                            switch (data.error_type) {
                                case 'not_working_time':
                                    title = translate.workingDayIsOver;
                                    break;
                                case 'non_correct_data':
                                case 'no required fields':
                                case 'please choose time':
                                    title = translate.incorrectData;
                                    if (data.field && data.field === 'phone') {
                                        var $phoneWrap = $form.find('.field_phone');
                                        $phoneWrap.addClass('error');
                                        $phoneWrap.find('input').one('keyup', function () {
                                            $(this).closest('.field_phone').removeClass('error');
                                        });
                                    } else if (data.field && data.field === 'time') {
                                        // title = 'Пожалуйста выберите время звонка';
                                        var $timeSelectWrap = $delayWrap.find('.field_wrap');
                                        $timeSelectWrap.addClass('error');
                                        $timeSelectWrap.find('.hidden_value').one('change', function () {
                                            $timeSelectWrap.removeClass('error');
                                        });
                                    }
                                    break;
                                case 'callback exist timeout':
                                    // text = 'Не больше 1 обратного звонка раз в 2 минуты';
                                    title = translate.sorryWasError;
                                    hint = translate.alreadyOrdered;
                                    break;
                                default:
                                    title = translate.sorryWasError;
                                    hint = translate.tryAgain;
                                    break;
                            }
                            loading_class = 'danger';
                        } else {
                            title = translate.thanksForReachingOut;
                            hint = translate.willCallYouShortly;
                            if (is_choose_time) {
                                hint = translate.willCallYouChosenTime;
                                var isBotOnline = false;
                                if (isBotOnline && Number(params.city_id) === 3) {
                                    var whatsAppBotHtml = '<img src="/img/svg/icons/robot.svg" class="robot" width="110" height="139">' + '<div class="w-clbk-whatsapp-text">' + translate.virtualAssistant + '</div>' + '<a class="action-button action-button-warning fw-m"' + ' href="https://wa.me/77478011869?text=Привет!">' + translate.writeToWhatsapp + '</a>';
                                    $callBackFormsWrap.addClass('with-whatsapp');
                                    $callBackFormsWrap.find('.w-clbk-r-whatsapp').html(whatsAppBotHtml);
                                }
                            }
                        }

                        $title.html(title);
                        $hint.html(hint);
                    }
                };

                if ($formTypeIdInput.val() == SOURCE_SEARCH_CRUISE) {
                    window.brxTracking.sendAnalyticsEvent('cruise_fakedoor_request_mobile');
                }
                window.createCallback(params);
            }).on('change', '.w-clbk-form .callback_city_id', function () {
                var cityData = window.getCityDataById(this.value);
                if (cityData) {
                    var cityPhonesData = window.getPhonesByCityData(cityData);
                    if (cityPhonesData.beautyPhone.length) {
                        var $callbackForm = $(this).closest('.w-clbk-form');
                        $callbackForm.find('.js_phone_mobile').html(cityPhonesData.beautyMobilePhone);

                        var $promotionPage = $callbackForm.closest('.promotion-callback-wrapper');
                        if ($promotionPage.length) {
                            $promotionPage.find('.phone-wrapper').html(cityPhonesData.beautyMobilePhone);
                        }
                    }
                    // force roistat change
                    window.brxTracking.callTrackingRefresh();
                }
            }).on('switchCallbackFormTheme', '.w-clbk-form', function (event, theme) {
                switchCallbackFormTheme($(this), theme);
            }).on('click', '.js_phone_mobile', function () {
                window.brxTracking.sendAnalyticsEvent('click_on_phone_number');
            }).on('click', '.get_callback', function () {
                window.brxTracking.sendAnalyticsEvent('click_on_call_me_back');
            });

            // отслеживаем действия для совершения звонка
            $('body').on('submit', '.w-clbk-form', function () {
                window.stat('phone.actionToCall', { info: 'place.createCallback' });
            }).on('click', '.clickable-phone', function () {
                window.stat('phone.actionToCall', { info: 'place.clickablePhone' });
            }).on('click', '.contacts-main-btn', function () {
                window.stat('phone.actionToCall', { info: 'place.headerPhoneBtn' });
            }).on('click', '.open_callback', function () {
                window.stat('phone.actionToCall', { info: 'place.fixedCornerCallbackBtn' });
            });
        });
    }, {}] }, {}, [1]);